<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex xs12 sm7 md7>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center mt-5 class="cont_page">
          <v-flex xs12>
            <h3 class="t-first">Português A1.1</h3>
          </v-flex>
          <v-flex class="cont-img animated fadeInUp dura-2" md5 xs11 mt-4>
              <v-card color="transparent" flat tile>
                
                  <v-window v-model="onboarding">
                    <v-window-item  v-for="n in length" :key="`card-${n}`">
                      <v-card class="cont_text-slider" color="transparent" flat height="130">
                        <h3 class="t-blue">{{n}}</h3>
                        <p>{{textoSlide[n-1]}}</p>
                      </v-card>
                    </v-window-item>
                  </v-window>

                  <v-card-actions class="cont_buttons-slider">
                    <v-item-group light v-model="onboarding" class="text-center " mandatory>
                      <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
                        <v-btn color="#D3D2D2" small class="item-button" :input-value="active" icon @click="toggle">
                          <v-icon >mdi-record</v-icon>
                        </v-btn>
                      </v-item>
                    </v-item-group>
                  </v-card-actions>

              </v-card>
          </v-flex>
        </v-layout>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Depois de concluir este nível, você será capaz de:'
      ],
      textoSlide:[
        'Entender e usar expressões familiares e cotidianas, bem como comunicar-se de forma muito simples.',
        'Apresentar-se ou apresentar alguém e fazer ou responder perguntas sobre temas cotidianos.',
        'Comunicar-se sem dificuldade sempre que o seu interlocutor falar lenta e claramente e estiver disposto a contribuir para o estabelecimento de uma comunicação básica.'
      ],
      length: 3,
      onboarding: 0,
    }
  },
  methods: {

  },
  watch: {
    onboarding(){
      if(this.onboarding == 2){
        this.$store.commit('nextShow', true);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.cont_text-slider{
  p{
  font-family: Poppins-Regular;
  font-size: 12px;
  }
}
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 20px;
    height: 20px;
  }
}
.t-blue{
  color: #084476;
  font-family:Poppins-BoldItalic;
  font-size: 40px;
}
.t-first{
   font-family:Poppins-BoldItalic;
   font-size: 20px;
}

</style>
